import { Pipe, PipeTransform, ChangeDetectorRef } from '@angular/core';
import { MmTranslateService } from './translate.service';
import { tap } from 'rxjs/operators';

@Pipe({
  name: 'mmTranslate'
})
export class MmTranslatePipe implements PipeTransform {

  constructor(private translateService: MmTranslateService, private cdf: ChangeDetectorRef) {

  }
  value: string;
  transform(value: any, ...args: string[]): any {
    

    this.translateService.format(value,...args).pipe(
      tap(val => {
        this.value = val;
        this.cdf.markForCheck();
      })
    ).subscribe();
    return this.value;;
  }

}
